module.exports = __webpack_public_path__ + "static/media/400064_02.7f8b75e3.png";